import OrderQuery from 'Query/Order.query';
import {
    CartDispatcher,
    OrderDispatcher as SourceOrderDispatcher
} from 'SourceStore/Order/Order.dispatcher';
import { showNotification } from 'Store/Notification/Notification.action';
import { getOrderList, setAddingToFavoritesStatus, setLoadingStatus } from 'Store/Order/Order.action';
import { fetchMutation, fetchQuery, getErrorMessage } from 'Util/Request';

export {
    CartDispatcher
};

/** @namespace PeggysagePwa/Store/Order/Dispatcher */
export class OrderDispatcher extends SourceOrderDispatcher {
    /**
     * Override: add parameter to add requested orders to the list instead of replacing them (standard pagination)
     * @param dispatch
     * @param page
     * @param loadMore
     * @returns {*}
     */
    requestOrders(dispatch, page = 1, loadMore = false, filter = {}) {
        const query = OrderQuery.getOrderListQuery({ page, ...filter });

        dispatch(setLoadingStatus(true));

        return fetchQuery(query).then(
            /** @namespace PeggysagePwa/Store/Order/Dispatcher/OrderDispatcher/requestOrders/fetchQuery/then */
            ({ customer: { orders } }) => {
                dispatch(getOrderList(orders, false, loadMore));
            },
            /** @namespace PeggysagePwa/Store/Order/Dispatcher/OrderDispatcher/requestOrders/fetchQuery/then/catch */
            (error) => {
                dispatch(showNotification('error', getErrorMessage(error)));
                dispatch(setLoadingStatus(false));
            }
        );
    }

    async addOrderToFavorites(dispatch, incrementId) {
        try {
            dispatch(setAddingToFavoritesStatus(true));

            const {
                addOrderToFavorites
            } = await fetchMutation(OrderQuery.addOrderToFavorites(incrementId));

            if (addOrderToFavorites) {
                dispatch(showNotification('success', __('Order added to favorites!')));
            } else {
                dispatch(showNotification('success', __('Error adding order to favorites')));

                return Promise.reject();
            }
        } catch {
            dispatch(showNotification('error', __('Error adding order to favorites')));

            return Promise.reject();
        } finally {
            dispatch(setAddingToFavoritesStatus(false));
        }

        return Promise.resolve();
    }

    async removeOrderFromFavorites(dispatch, incrementId) {
        try {
            dispatch(setAddingToFavoritesStatus(true));

            const {
                removeOrderFromFavorites
            } = await fetchMutation(OrderQuery.removeOrderFromFavorites(incrementId));

            if (removeOrderFromFavorites) {
                dispatch(showNotification('success', __('Order removed from favorites!')));
            } else {
                dispatch(showNotification('success', __('Error removing order from favorites')));

                return Promise.reject();
            }
        } catch {
            dispatch(showNotification('error', __('Error removing order from favorites')));

            return Promise.reject();
        } finally {
            dispatch(setAddingToFavoritesStatus(false));
        }

        return Promise.resolve();
    }
}

export default new OrderDispatcher();
